/* GLLF Occasions (v1): one date brain for the gift tracker, delivery bar, gift pages and cart.
   Every date is worked out from the calendar each year in US Eastern time, so nothing needs editing year to year.
   Gifting occasions (with order-by dates): Valentine's Day, Easter, Mother's Day, Father's Day, Grandparents Day, Christmas.
   Seasons and theme weeks follow the same rules as the homepage farm scene (winter, spring, summer, fall,
   Halloween week Oct 17-31, Thanksgiving week, Christmas). */
(function () {
  'use strict';
  if (window.GLLFOccasions) return;
  var DAY = 864e5, TZ = 'America/New_York';
  var p2 = function (n) { return (n < 10 ? '0' : '') + n; };
  function ymd(ms) {
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric' }).formatToParts(new Date(ms)), o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day };
  }
  function wd(y, m, d) { return new Date(Date.UTC(y, m - 1, d)).getUTCDay(); } /* 0 Sun .. 6 Sat */
  function nth(y, m, dow, n) { var first = wd(y, m, 1); return 1 + ((dow - first + 7) % 7) + (n - 1) * 7; }
  function dstOn(y, m, d) { /* US daylight time: 2nd Sunday of March to 1st Sunday of November */
    var start = nth(y, 3, 0, 2), end = nth(y, 11, 0, 1);
    if (m > 3 && m < 11) return true; if (m < 3 || m > 11) return false;
    return m === 3 ? d >= start : d < end;
  }
  function at(y, m, d, t) { /* calendar date + time in Eastern time -> epoch ms (rolls over month/year ends) */
    var base = new Date(Date.UTC(y, m - 1, d)); y = base.getUTCFullYear(); m = base.getUTCMonth() + 1; d = base.getUTCDate();
    return Date.parse(y + '-' + p2(m) + '-' + p2(d) + 'T' + (t || '23:59') + ':00' + (dstOn(y, m, d) ? '-04:00' : '-05:00'));
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3),
      h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, mm = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * mm + 114) / 31), da = ((h + l - 7 * mm + 114) % 31) + 1;
    return [mo, da];
  }
  function shift(y, m, d, n) { var t = new Date(Date.UTC(y, m - 1, d + n)); return [t.getUTCFullYear(), t.getUTCMonth() + 1, t.getUTCDate()]; }
  function backToWeekday(ymdArr) { var w = wd(ymdArr[0], ymdArr[1], ymdArr[2]); return w === 6 ? shift(ymdArr[0], ymdArr[1], ymdArr[2], -1) : w === 0 ? shift(ymdArr[0], ymdArr[1], ymdArr[2], -2) : ymdArr; }

  /* look: sky colors, falling particles, the moving carrier and the painted icons it uses */
  var DEFS = {
    valentines: {
      name: 'Valentine’s Day', short: 'Valentine’s', when: function (y) { return [2, 14]; }, opensDaysBefore: 25,
      tracker: 'Love letter tracker', carrier: 'letters', icon: 'love-letter', bar: 'love-letter', who: 'year',
      sky: ['#2b1631', '#6d2f55'], fx: 'hearts',
      stages: ['Love is in the air', 'Sealed with a kiss', 'Hearts racing', 'Special delivery', 'Love on overtime', 'Too late to post']
    },
    easter: {
      name: 'Easter', short: 'Easter', when: function (y) { return easter(y); }, opensDaysBefore: 35, faith: true,
      tracker: 'Easter basket tracker', carrier: 'bunny', icon: 'rabbit', bar: 'rabbit', who: 'year',
      sky: ['#203457', '#5d6fa3'], fx: 'petals',
      stages: ['Spring has sprung', 'Eggs are hatching', 'The bunny is hopping', 'Basket’s almost full', 'Hop to it', 'The bunny has hopped off'],
      verse: ['“He is not here: for he is risen, as he said.”', 'Matthew 28:6 (KJV)'], faithTitle: ['He is', 'risen'], faithArt: ['latin-cross', 'tulip']
    },
    mothers: {
      name: 'Mother’s Day', short: 'Mother’s Day', when: function (y) { return [5, nth(y, 5, 0, 2)]; }, opensDaysBefore: 30,
      tracker: 'Bouquet tracker', carrier: 'bouquet', icon: 'bouquet', bar: 'bouquet', who: 'year',
      sky: ['#2c2a52', '#6b5a92'], fx: 'petals',
      stages: ['In full bloom', 'Fresh cut', 'Buds are opening', 'Last petals', 'Express bouquet only', 'The bouquet has left']
    },
    fathers: {
      name: 'Father’s Day', short: 'Father’s Day', when: function (y) { return [6, nth(y, 6, 0, 3)]; }, opensDaysBefore: 30,
      tracker: 'Canoe tracker', carrier: 'canoe', icon: 'canoe', bar: 'canoe', who: 'him',
      sky: ['#14304d', '#3f6b8c'], fx: 'fireflies',
      stages: ['Calm waters', 'Smooth paddling', 'Picking up the pace', 'Rapids ahead', 'Full speed', 'Already set sail']
    },
    grandparents: {
      name: 'Grandparents Day', short: 'Grandparents Day', when: function (y) { return [9, nth(y, 9, 1, 1) + 6]; }, opensDaysBefore: 21,
      tracker: 'Tractor tracker', carrier: 'tractor', icon: 'tractor', bar: 'tractor', who: 'garden',
      sky: ['#23324f', '#5c6b8e'], fx: 'leaves',
      stages: ['Sunny fields', 'Steady rows', 'Harvest time', 'Last load', 'Full throttle', 'The tractor’s gone home']
    },
    christmas: {
      name: 'Christmas', short: 'Christmas', when: function (y) { return [12, 25]; }, opensOn: [11, 1], faith: true,
      tracker: 'Santa’s sleigh tracker', carrier: 'sleigh', icon: 'sled', bar: 'sled', who: 'xmas',
      sky: ['#1d1530', '#3b2b58'], fx: 'snow',
      stages: ['Clear skies', 'Light snow', 'Frosty runners', 'Blizzard watch', 'Reindeer on double time', 'The sleigh has left the barn'],
      verse: ['“For unto you is born this day in the city of David a Saviour, which is Christ the Lord.”', 'Luke 2:11 (KJV)'], faithTitle: ['Celebrating the birth of', 'Jesus'], faithArt: ['church', 'glowing-star']
    }
  };

  function build(id, y, over) {
    var o = DEFS[id], md = o.when(y), H = [y, md[0], md[1]];
    var dOff = function (n) { return shift(H[0], H[1], H[2], n); };
    var A = function (arr, t) { return at(arr[0], arr[1], arr[2], t); };
    var picks = [], k = -2; while (picks.length < 2 && k > -20) { var c = dOff(k); var w = wd(c[0], c[1], c[2]); if (w === 3 || w === 5) picks.push(c); k--; }
    var D = {
      id: id, year: y, def: o,
      start: o.opensOn ? at(y, o.opensOn[0], o.opensOn[1], '00:00') : A(dOff(-o.opensDaysBefore), '00:00'),
      ground: A(backToWeekday(dOff(-11))), priority: A(backToWeekday(dOff(-8))), express: A(backToWeekday(dOff(-4)), '12:00'),
      pickupDay: A(picks[0], '10:00'), pickupOrder: A(shift(picks[0][0], picks[0][1], picks[0][2], -2)),
      pickupPrevDay: A(picks[1], '10:00'), pickupPrevOrder: A(shift(picks[1][0], picks[1][1], picks[1][2], -2)),
      day: A(H, '00:00'), faithStart: o.faith ? A(dOff(-1), '00:00') : A(H, '00:00'),
      end: A(dOff(o.faith ? 2 : 1), '00:00')
    };
    D.stagesAt = [Math.max(D.start, D.ground - 13 * DAY), D.ground - 4 * DAY, D.ground, D.priority, D.express, D.faithStart];
    /* optional one-year overrides from the theme, e.g. { christmas: { ground: "2027-12-13T23:59:00-05:00" } } */
    var ov = over && (over[id] || (id === 'christmas' && over.ground ? over : null));
    if (ov) Object.keys(ov).forEach(function (key) { var t = Date.parse(ov[key]); if (!isNaN(t) && ymd(t).y === y && typeof D[key] === 'number') D[key] = t; });
    return D;
  }

  function current(nowMs, over) {
    var y = ymd(nowMs).y, best = null;
    [y - 1, y, y + 1].forEach(function (yy) {
      Object.keys(DEFS).forEach(function (id) {
        var D = build(id, yy, over);
        if (nowMs >= D.start && nowMs < D.end && (!best || D.day < best.day)) best = D;
      });
    });
    return best;
  }

  /* season / theme week, same rules as the homepage scene */
  function season(nowMs) {
    var t = ymd(nowMs), m = t.m, d = t.d;
    if (m === 12 || (m === 1 && d <= 6)) return 'christmas';
    if (m === 10 && d >= 17) return 'halloween';
    if (m === 11) { var tg = nth(t.y, 11, 4, 4); if (Math.abs(d - tg) <= 4) return 'thanksgiving'; }
    return m <= 2 ? 'winter' : m <= 5 ? 'spring' : m <= 8 ? 'summer' : 'fall';
  }
  var SEASON_CARRIER = { christmas: 'sled', winter: 'sled', spring: 'butterfly', summer: 'sailboat', fall: 'tractor', halloween: 'jack-o-lantern', thanksgiving: 'turkey' };
  function carrierIcon(nowMs, over) { var o = current(nowMs, over); return o ? o.def.bar : SEASON_CARRIER[season(nowMs)]; }

  function nowMs() {
    try {
      var q = new URLSearchParams(location.search).get('sleigh_date') || new URLSearchParams(location.search).get('gift_date');
      if (q) { var t = Date.parse(/[zZ]|[+-]\d\d:\d\d$/.test(q) ? q : q + (dstOn(+q.slice(0, 4), +q.slice(5, 7), +q.slice(8, 10)) ? '-04:00' : '-05:00')); if (!isNaN(t)) return t; }
    } catch (e) {}
    return Date.now();
  }

  window.GLLFOccasions = { DAY: DAY, defs: DEFS, build: build, current: current, season: season, carrierIcon: carrierIcon, now: nowMs, ymd: ymd, at: at };
})();
